/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import QRCode from "react-qr-code";
import html2canvas from 'html2canvas';
import * as _ from 'lodash'
import { DEPOSIT_MQR_DEMO_BTN, DEPOSIT_MQR_TIMER_SEC, DEPOSIT_XOROPE_TIMER, DepositXoropeOptionsFileUpload, MINIMUM_DEPOSIT } from '../configs/B2C.config';
import { depositOrder } from '../services/depositWithdrawalService';
import { postMQRManualPayment, postManualPayment, postManualPaymentJson, postManualPaymentNew, submitWithUtr } from '../services/xoroService';
import { staticContentsImagePath as BASE_IMAGE_PATH } from "../configs/const";
import { isJsonString } from '../util/jsoncnvt.util.js';
import Loader from "../images/Iphone-spinner-2.gif"
import PaymentSuccessModal from './sub_components/paymentSuccessModal.js';
import DepositDemoDropdownMenu from './sub_components/depositDemoDropdownMenu.js';
// import { getDepositBonusOffers, getIFSCCodeDetails, getManualWithdrawal, getMyPreviousBank, getXoroActiveProviderData, getXoroDataNew } from '../services/xoroService';
let mqrQRTimer;
let xoropeTimer;
let socket = null;

class WalletDepositInnerComp extends Component {
    csvLink = React.createRef();
    constructor(props) {
        super(props);
        this.state = {
            utr: null,
            ss: {},
            ssbase64: null,
            buttonLoader: false,
            mqrImgDt: '',
            upiDirectButtonLink: {},
            receiptID: '',
            mqrtimerseconds: 0,
            mqrtimerdisplay: '',
            utrNumber: null,
            xoroPeSeconds: 0,
            showPopup: false,
            savedRecieptID: '',
            savedUtr: '',
            customerUpi: '',
            selectedPaymentModeOption: ''
        };
        this.selectFile = this.selectFile.bind(this);
    }

    componentDidMount() {

        // if(!!this.props?.activePaymentOption && !!this.props?.activePaymentOption?.gatewayProvider && this.props?.activePaymentOption?.gatewayProvider !== "XOROPE" && !!this.props?.activePaymentOption.paymentModeOptions){
        //     this.setState({
        //         selectedPaymentModeOption: !!this.props?.activePaymentOption.paymentModeOptions[0]
        //     })
        // }

        socket = this.props.socket;
        socket.on("site_room", async (data) => {
            let msg = isJsonString(data);
            if (!msg || msg.command !== "USER.DEPOSIT") {
                return;
            }

            const shouldShowPopup = this.props.gateWay === 'mqr'
                ? msg?.payload?.txnId === this.state.savedRecieptID
                : msg?.payload?.txnId === this.state.savedUtr;

            if (shouldShowPopup) {
                this.props.showPopup({ showPopup: false, xoroPeSeconds: 0 });

                setTimeout(() => {
                    this.props.MySwal.fire({
                        title: msg.payload.isSuccess ? 'Success.' : 'Rejected, Try again.',
                        text: msg.payload.message,
                        icon: msg.payload.isSuccess ? 'success' : "error",
                        confirmButtonText: 'OK',
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.href = "/home";
                        } else {
                            if (!!document.getElementById(`formFile_${this.props.gateWay}`)) {
                                document.getElementById(`formFile_${this.props.gateWay}`).value = "";
                            }
                        }
                    })
                }, 1000);
            }
        });
    }
    componentDidUpdate(prevProps) {
        if (prevProps.gateWay !== this.props.gateWay) {
            this.setState({
                utr: null,
                mqrImgDt: '',
                upiDirectButtonLink: {},
                receiptID: '',
                mqrtimerseconds: 0,
                mqrtimerdisplay: '',
                xoroPeSeconds: 0,
                utrNumber: null,
            });
        }
    }

    selectFile(e) {
        let imgData = {
            currentFile: e.target.files[0],
            previewImage: URL.createObjectURL(e.target.files[0]),
            progress: 0,
            message: "",
        };
        this.setState({ ss: imgData }, () => {
            if (!!this.state.ss && !!this.state.ss.currentFile) {
                let reader = new FileReader();
                reader.onloadend = () => {
                    let imgdt = reader.result;
                    let imgdtsplt = imgdt.split(",")[1];
                    this.setState({ ssbase64: imgdtsplt });
                }
                reader.readAsDataURL(this.state.ss.currentFile);
            }
        });
    }

    onSubmitClick() {
        if (this.props?.activePaymentOption?.gatewayProvider !== "XOROPE") {
            this.onNonXoropeDepositClick()
        } else {
            if (this.props.gateWay === 'mqr') {
                // ['cash', 'mqr'].includes(this.props.gateWay)
                this.mqrSubmitFirstPayment();
            } else {
                //this.onXoropeDepositClick();
                this.onXoropeDepositJsonClick();
            }
        }
    }

    onCancelClick() {
        window.location.pathname = "/wallet/deposit";
    }

    onNonXoropeDepositClick() {
        const self = this;
        // if (this.state.amount < this.state.activePaymentOption.gatewayProvider.minLimit) {
        //     this.props.notify(`Minimum deposit amount is ${this.state.activePaymentOption.gatewayProvider.minLimit}`, "warning");
        //     return false;
        // }
        if (this.props.amount === 0 || !this.props.amount) {
            self.props.notify("Select amount", "error");
            return false;
        }
        if (['ICEPE', 'ICEPE1X', 'PAYOK'].includes(this.props?.activePaymentOption?.gatewayProvider?.pgName) && (!(!!this.state.customerUpi) || !(/^[\w.-]+@[\w.-]+$/.test(this.state.customerUpi)))) {
            self.props.notify("Provide valid UPI address", "error");
            return false;
        }
        let body = {
            // operatorId: this.props.operatorId,
            // username: this.props.userId,
            amount: this.props.amount,
            clientBonusId: !!this.props.bonusOfferApplied ? this.props.bonusOfferApplied : "",
            gatewayProvider: this.props?.activePaymentOption?.gatewayProvider?.pgName,
            customerUpi: ['ICEPE', 'ICEPE1X', 'PAYOK'].includes(this.props?.activePaymentOption?.gatewayProvider?.pgName) ? this.state.customerUpi : ''
            // appliedBonus: this.props.bonusOfferApplied,
            // bonusPercentage: this.props.bonusOfferApplied && !!this.props.availableBonusOffers ? this.props.availableBonusOffers : 0,
        };
        if (!!this.props?.activePaymentOption.paymentModeOptions) {
            if (!(!!this.state.selectedPaymentModeOption)) {
                self.props.notify("Select payment mode", "error");
                return false;
            }
            body['paymentMode'] = this.state.selectedPaymentModeOption
        }
        this.setState({ buttonLoader: true }, () => {
            depositOrder(body)
                .then((res) => {
                    if (!!res) {
                        if (!!res.orderId) {
                            //self.setState({ buttonLoader: false });

                            if (['PAYOK'].includes(self.props?.activePaymentOption?.gatewayProvider?.pgName)) {
                                window.open(res.url, "_blank")
                                window.location.href = '/home'
                            } else {
                                window.location.href = res.url;
                            }
                        } else {
                            self.props.notify(
                                res.exception.message,
                                "error"
                            );
                            self.setState({ buttonLoader: false });
                        }
                    } else {
                        self.setState({ buttonLoader: false });
                    }
                })
                .catch((error) => {
                    self.props.notify(error, "error");
                    self.setState({ buttonLoader: false });
                });
        })
    }

    onXoropeDepositClick() {
        const self = this;
        let frmData = new FormData();
        let cp = this.props.gateWay;
        const pymntMd = {
            "phonepe": "PhonePe",
            "googlepay": "GooglePay",
            "paytm": "Paytm",
            "upi": "Upi",
            "bank": "Bank",
            "bankpr": "BankPR",
            "wallet": "Wallet",
            "crypto": "Crypto",
            "rocket": "Rocket",
            "upay": "Upay",
            "bkash": "Bkash",
            "nagad": "Nagad"
        }
        if (
            this.props.amount === null ||
            this.props.amount === 0 ||
            this.props.amount === ""
        ) {
            this.props.notify("Enter amount", "error");

            return false;
        }
        //  else if (this.props.amount < MINIMUM_DEPOSIT) {
        //     this.props.notify(`Please enter min amount of ${MINIMUM_DEPOSIT}.`, "error");

        //     return false;
        // }
        else if ((this.state.utr === null || this.state.utr === "") && cp !== "cash") {
            this.props.notify(cp === "bankpr" || cp === "wallet" ? "Enter Transaction no." : (["nagad", "bkash", "rocket", "upay"].includes(cp) ? "Enter Transaction ID." : "Enter UTR number"), "error");
            return false;
        } else if ((cp === "bankpr" || cp === "wallet") && !(this.state.utr.length > 8 && this.state.utr.length < 15)) {
            this.props.notify(
                "Transaction No. should be 9 to 14 digits long.",
                "error"
            );
            return false;
        } else if (["nagad", "bkash", "rocket", "upay"].includes(cp) && this.state.utr.length < 8) {
            this.props.notify(
                "Provide valid Transaction ID.",
                "error"
            );
            return false;
        } else if (cp !== "cash" && this.state.utr.length !== 12 && !["cash", "crypto", "bankpr", "wallet", "nagad", "bkash", "rocket", "upay"].includes(cp)) {
            this.props.notify(
                "Invalid UTR number. Enter 12 digit UTR number",
                "error"
            );
            return false;
        }
        else if (this.props?.activePaymentOption?.screenshot && (!this.state.ss.currentFile || this.state.ss.currentFile === null) && cp !== "cash") {
            this.props.notify("Please upload payment screen-shot", "error");
            return false;
        }
        // frmData.append("username", this.props.userId);
        if (this.props?.activePaymentOption?.screenshot && cp !== "cash") {
            frmData.append("ss_file", this.state.ss.currentFile);
        }
        frmData.append("email", this.props.emailId);
        frmData.append("mobile", this.props.mobileNumber);
        frmData.append("amount", this.props.amount);
        frmData.append("paymentMode", (!!pymntMd[cp] ? pymntMd[cp].trim() : "Cash"));
        frmData.append("operatorId", this.props?.activePaymentOption.operatorId);
        frmData.append(
            "accountName",
            cp === "bank" || cp === "bankpr"
                ? this.props.activePaymentOption.holderName
                : cp === "crypto"
                    ? this.props.activePaymentOption.holderName
                    : cp === "cash"
                        ? "cash"
                        : this.props.activePaymentOption.holderName
        );
        frmData.append(
            "accountId",
            (cp === "bank" || cp === "bankpr")
                ? this.props.activePaymentOption.accountNumber
                : cp === "crypto"
                    ? this.props.activePaymentOption.accountNumber
                    : cp === "cash"
                        ? "cash"
                        : this.props.activePaymentOption.accountNumber
        );
        frmData.append("utrNumber", this.state.utr);
        frmData.append("clientBonusId", (!!this.props.bonusOfferApplied ? this.props.bonusOfferApplied : ""))
        // frmData.append("appliedBonus", this.props.bonusOfferApplied)
        // frmData.append("bonusPercentage", this.props.bonusOfferApplied && !!this.props.availableBonusOffers ? this.props.availableBonusOffers : 0)
        // frmData.append("gatewayProvider", this.props.activePaymentOption?.gatewayProvider)
        this.setState({ buttonLoader: true }, () => {
            postManualPayment(frmData).then((res) => {
                if (!!res && res.isSuccess) {
                    let secs = DEPOSIT_XOROPE_TIMER;
                    self.setState(
                        { xoroAmount: '', ss: {}, ssbase64: null, utr: "", buttonLoader: false, xoroPeSeconds: secs, showPopup: true, savedUtr: this.state.utr },
                        () => {
                            // self.props.MySwal.fire({
                            //     title: 'Success.',
                            //     text: res.data.message,
                            //     icon: 'success',
                            //     confirmButtonText: 'OK',
                            // }).then((result) => {
                            //     if (result.isConfirmed) {
                            //         window.location.href = "/home";
                            //     } else {
                            //         if (!!document.getElementById(`formFile_${this.props.gateWay}`)) {
                            //             document.getElementById(`formFile_${this.props.gateWay}`).value = "";
                            //         }
                            //     }
                            // })
                            self.props.showPopup({ showPopup: true, xoroPeSeconds: secs });
                            self.xoropeTimerStart();
                        }
                    );


                } else {
                    self.setState({ buttonLoader: false });
                    self.props.notify(res.exception.message, "error");
                }
            });
        });
    }



    onXoropeDepositJsonClick() {
        const self = this;
        let frmData = {}//new FormData();
        let cp = this.props.gateWay;
        const pymntMd = {
            "phonepe": "PhonePe",
            "googlepay": "GooglePay",
            "paytm": "Paytm",
            "upi": "Upi",
            "bank": "Bank",
            "bankpr": "BankPR",
            "wallet": "Wallet",
            "crypto": "Crypto",
            "rocket": "Rocket",
            "upay": "Upay",
            "bkash": "Bkash",
            "nagad": "Nagad"
        }
        if (
            this.props.amount === null ||
            this.props.amount === 0 ||
            this.props.amount === ""
        ) {
            this.props.notify("Enter amount", "error");

            return false;
        }
        //  else if (this.props.amount < MINIMUM_DEPOSIT) {
        //     this.props.notify(`Please enter min amount of ${MINIMUM_DEPOSIT}.`, "error");

        //     return false;
        // }
        else if ((this.state.utr === null || this.state.utr === "") && cp !== "cash") {
            this.props.notify(cp === "bankpr" || cp === "wallet" ? "Enter Transaction no." : (["nagad", "bkash", "rocket", "upay"].includes(cp) ? "Enter Transaction ID." : "Enter UTR number"), "error");
            return false;
        } else if ((cp === "bankpr" || cp === "wallet") && !(this.state.utr.length > 8 && this.state.utr.length < 15)) {
            this.props.notify(
                "Transaction No. should be 9 to 14 digits long.",
                "error"
            );
            return false;
        } else if (["nagad", "bkash", "rocket", "upay"].includes(cp) && this.state.utr.length < 8) {
            this.props.notify(
                "Provide valid Transaction ID.",
                "error"
            );
            return false;
        } else if (cp !== "cash" && this.state.utr.length !== 12 && !["cash", "crypto", "bankpr", "wallet", "nagad", "bkash", "rocket", "upay"].includes(cp)) {
            this.props.notify(
                "Invalid UTR number. Enter 12 digit UTR number",
                "error"
            );
            return false;
        }
        else if (this.props?.activePaymentOption?.screenshot && (!this.state.ss.currentFile || this.state.ss.currentFile === null) && cp !== "cash") {
            this.props.notify("Please upload payment screen-shot", "error");
            return false;
        }
        // frmData.append("username", this.props.userId);
        if (this.props?.activePaymentOption?.screenshot && cp !== "cash") {
            frmData["ssFileBase64"] = this.state.ssbase64;
            frmData["FileName"] = this.state.ss.currentFile.name;//this.state.ss.currentFile;
        }
        frmData["email"] = this.props.emailId;
        frmData["mobile"] = this.props.mobileNumber;
        frmData["amount"] = this.props.amount;
        frmData["paymentMode"] = (!!pymntMd[cp] ? pymntMd[cp].trim() : "Cash");
        frmData["operatorId"] = this.props?.activePaymentOption.operatorId;
        frmData["accountName"] =
            cp === "bank" || cp === "bankpr"
                ? this.props.activePaymentOption.holderName
                : cp === "crypto"
                    ? this.props.activePaymentOption.holderName
                    : cp === "cash"
                        ? "cash"
                        : this.props.activePaymentOption.holderName
            ;
        frmData["accountId"] =
            (cp === "bank" || cp === "bankpr")
                ? this.props.activePaymentOption.accountNumber
                : cp === "crypto"
                    ? this.props.activePaymentOption.accountNumber
                    : cp === "cash"
                        ? "cash"
                        : this.props.activePaymentOption.accountNumber
            ;
        frmData["utrNumber"] = this.state.utr;
        frmData["clientBonusId"] = !!this.props.bonusOfferApplied ? this.props.bonusOfferApplied : "";
        // frmData.append("appliedBonus", this.props.bonusOfferApplied)
        // frmData.append("bonusPercentage", this.props.bonusOfferApplied && !!this.props.availableBonusOffers ? this.props.availableBonusOffers : 0)
        // frmData.append("gatewayProvider", this.props.activePaymentOption?.gatewayProvider)
        this.setState({ buttonLoader: true }, () => {
            postManualPaymentJson(frmData).then((res) => {
                if (!!res && res.isSuccess) {
                    let secs = DEPOSIT_XOROPE_TIMER;
                    self.setState(
                        { xoroAmount: '', ss: {}, ssbase64: null, utr: "", buttonLoader: false, xoroPeSeconds: secs, showPopup: true, savedUtr: this.state.utr },
                        () => {
                            // self.props.MySwal.fire({
                            //     title: 'Success.',
                            //     text: res.data.message,
                            //     icon: 'success',
                            //     confirmButtonText: 'OK',
                            // }).then((result) => {
                            //     if (result.isConfirmed) {
                            //         window.location.href = "/home";
                            //     } else {
                            //         if (!!document.getElementById(`formFile_${this.props.gateWay}`)) {
                            //             document.getElementById(`formFile_${this.props.gateWay}`).value = "";
                            //         }
                            //     }
                            // })
                            self.props.showPopup({ showPopup: true, xoroPeSeconds: secs });
                            self.xoropeTimerStart();
                        }
                    );


                } else {
                    self.setState({ buttonLoader: false });
                    self.props.notify(res.exception.message, "error");
                }
            });
        });
    }



    mqrSubmitFirstPayment() {
        const self = this;

        let cp = this.props.gateWay;
        if (
            this.props.amount === null ||
            this.props.amount === 0 ||
            this.props.amount === ""
        ) {
            this.props.notify("Enter amount", "error");
            return false;
        } else if (this.props.amount < 100) {
            this.props.notify("Enter min amount of 100.", "error");
            return false;
        }

        let frmData = {
            "email": this.props.emailId,
            "mobile": this.props.mobileNumber,
            "amount": this.props.amount,
            "accountOperatorId": this.props.activePaymentOption.operatorId,
            "clientBonusId": !!this.props.bonusOfferApplied ? this.props.bonusOfferApplied : ""
            // "account_name": this.props.activePaymentOption.name,
            // "account_id": this.props.activePaymentOption.accountNumber,
            // "appliedBonus": this.props.bonusOfferApplied,
            // "bonusPercentage": this.props.bonusOfferApplied && !!this.props.availableBonusOffers ? this.props.availableBonusOffers : 0,
            // "gatewayProvider": this.props.activePaymentOption?.gatewayProvider
        }

        this.setState({ buttonLoader: true }, () => {
            postMQRManualPayment(frmData).then((res) => {
                if (!!res && res.isSuccess) {
                    const receiptNumber = res.data.receiptNumber;
                    const splitedqrAddress = res.data.qrAddress.split('&');
                    const pa = splitedqrAddress[0].split('=')[1];
                    const pn = splitedqrAddress[1].split('=')[1];
                    let appsbtn = {
                        'gpay': `tez://upi/pay?pa=${pa}&tr=${receiptNumber}&tn=${receiptNumber}&cu=INR&am=${self.props.amount}&pn=${pn}&mode=00&orgid=000000`,
                        'phonepe': `phonepe://pay?pa=${pa}&tr=${receiptNumber}&tn=${receiptNumber}&cu=INR&am=${self.props.amount}&pn=${pn}&mode=00&orgid=000000`,
                        'paytm': `paytm://pay?pa=${pa}&tr=${receiptNumber}&tn=${receiptNumber}&cu=INR&am=${self.props.amount}&pn=${pn}&mode=00&orgid=000000`,
                        'upi': res.data.qrAddress
                    }
                    let secs = DEPOSIT_MQR_TIMER_SEC;
                    let mqrtimerdisply = '';
                    if (secs > 0) {
                        let mins = DEPOSIT_MQR_TIMER_SEC / 60;
                        if (mins > 0) {
                            mqrtimerdisply = mqrtimerdisply + mins + 'm ';
                        }
                        mqrtimerdisply = mqrtimerdisply + secs + 's left';
                    }
                    self.setState({ mqrImgDt: res.data.qrAddress, buttonLoader: false, upiDirectButtonLink: appsbtn, receiptID: receiptNumber, mqrtimerseconds: secs, mqrtimerdisplay: mqrtimerdisply, savedRecieptID: receiptNumber }, () => {
                        self.mqrQRTimerStart();
                        self.props.setMqrImgDt(res.data.qrAddress);
                    });
                } else {
                    self.setState({ buttonLoader: false });
                    self.props.notify(res.exception.message, "error");
                }
            });
        });
    }

    submitPaymentWithUtr() {
        const self = this;
        let isValid = true;

        if (this.state.utrNumber === null || this.state.utrNumber === "") {
            this.props.notify("Enter UTR number", "error");
            isValid = false;
            return false;
        }
        if (this.state.utrNumber.length !== 12) {
            this.props.notify(
                "Invalid UTR number. Enter 12 digit UTR number",
                "error"
            );
            isValid = false;
        }

        if (isValid) {
            let body = {
                "amount": this.props.amount,
                "utrNumber": this.state.utrNumber,
                "receiptNumber": this.state.receiptID
            }

            submitWithUtr(body).then((res) => {
                if (res.isSuccess) {
                    let secs = DEPOSIT_XOROPE_TIMER;
                    self.setState({ xoroPeSeconds: secs, showPopup: true }, () => {
                        self.props.showPopup({ showPopup: true, xoroPeSeconds: secs });
                        self.xoropeTimerStart();
                    });
                } else {
                    self.props.showPopup({ showPopup: false, xoroPeSeconds: 0 });
                    self.props.notify(res.exception.message, "error");
                    self.setState({ utrNumber: null })
                }
            })
        }
    }

    mqrSubmitSecondPayment() {
        // this.props.hidePopup();
        this.props.MySwal.fire({
            title: 'Success.',
            text: 'Payment Request Received',
            icon: 'success',
            confirmButtonText: 'OK',
        }).then((result) => {
            if (result.isConfirmed) {
                // this.props.hidePopup();
            }
        })
    }

    goOutOfMQR() {
        let paymentTypes = Object.keys(this.state.xoroData['paymentMode']).filter(
            (pm, i) => {
                return this.state.xoroData['paymentMode'][pm].length > 0;
            }
        );
        this.setState({ curPaymentType: paymentTypes[0] }, () => {
            this.setState({
                curAccount: this.state.xoroData['paymentMode'][paymentTypes[0]][0],
            });
        });
    }

    xoropeTimerStart() {
        const self = this;
        xoropeTimer = setInterval(async function timerUpdator() {
            clearInterval(xoropeTimer);
            let secs = self.state.xoroPeSeconds - 1;
            self.setState({ xoroPeSeconds: secs }, () => {
                if (self.state.xoroPeSeconds > 0) {
                    self.props.showPopup({ showPopup: self.state.showPopup, xoroPeSeconds: secs });
                    xoropeTimer = setInterval(timerUpdator, 1000);
                } else {
                    clearInterval(self.xoropeTimer);
                    self.props.showPopup({ showPopup: true, xoroPeSeconds: 0 });
                }
            })
        }, 1000);
    }

    mqrQRTimerStart() {
        const self = this;
        mqrQRTimer = setInterval(async function timerUpdator() {
            clearInterval(mqrQRTimer);
            let secs = self.state.mqrtimerseconds - 1;
            let mqrtimerdisply = '';

            let mins = parseInt(secs / 60);
            if (mins > 0) {
                mqrtimerdisply = mqrtimerdisply + mins + 'm ';
            }
            mqrtimerdisply = mqrtimerdisply + (secs % 60) + 's left';


            self.setState({ mqrtimerseconds: secs, mqrtimerdisplay: mqrtimerdisply }, () => {
                if (self.state.mqrtimerseconds > 0) {
                    mqrQRTimer = setInterval(timerUpdator, 1000);
                } else {
                    window.location.pathname = '/wallet/deposit';
                    // self.props.hidePopup();
                }
            })
        }, 1000);
    }


    captureScreenshot() {
        const element = document.getElementById('screenshotElement'); // ID of the component to capture
        html2canvas(element).then(canvas => {
            const screenshot = canvas.toDataURL('image/png');
            const link = document.createElement('a');
            link.href = screenshot;
            link.download = `screenshot${this.state.receiptID}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    copyToClipboard(content) {
        navigator.clipboard.writeText(content);
        this.props.notify("Copied Successfully!", "info");
    }

    openDepositInfoPopup() {
        this.props.MySwal.fire({
            title: "<strong>Deposit Info</strong>",
            icon: "",
            html: `
      <div class="">
        <div>
          <h3>
            <span style="color: rgb(0, 168, 133);">
              <span style="font-size: 20px;">Payment Instruction</span> 
            </span>
          </h3>
          <p class="mb-0 text-black">Step 1: For payment, you will redirect to new page.</p>
          <p class="mb-0 text-black">Step 2: Complete the payment in the new page.</p>
          <p class="mb-0 text-black">Step 3: Close the page after completing payment.</p>
          <p class="mb-0 text-black">Step 4: Check transaction status by transaction report in report menu.</p>
          <p class="text-light-grey">--------------------------------------------------------</p>
          <p class="mb-0 text-black">चरण 1: भुगतान के लिए, आपको नए पेज पर रीडायरेक्ट किया जाएगा।</p>
          <p class="mb-0 text-black">चरण 2: नए पेज में भुगतान पूरा करें।</p>
          <p class="mb-0 text-black">चरण 3: भुगतान पूरा करने के बाद पेज बंद करें।</p>
          <p class="mb-0 text-black">चरण 4: रिपोर्ट मेनू में लेनदेन रिपोर्ट द्वारा लेनदेन की स्थिति की जाँच करें।</p>
        </div>
      </div>
      `,
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: 'Agree'
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                this.onNonXoropeDepositClick();
            }
        });
    }


    render() {
        const onlyAlphaNumeric = /[0-9a-zA-Z]+/g;
        return (
            <>
                {/* wizpay  payment Start */}
                {!!this.props?.activePaymentOption && !!this.props?.activePaymentOption?.gatewayProvider && this.props?.activePaymentOption?.gatewayProvider !== "XOROPE" &&
                    <div className="row manual-container-qr payment-details-box ">
                        <div className="col-12 col-sm-12 col-md-12">
                            <div className='row'>
                                <div className='col-12 col-sm-3 col-md-3'>
                                    <label htmlFor="inputPassword5" className="form-label">Amount (INR):</label>
                                    <input className="form-control" type="text" aria-label="Disabled input example" disabled value={this.props.amount}></input>
                                </div>
                                <div className='col-12 col-sm-3 col-md-3'>
                                    <label htmlFor="inputPassword5" className="form-label">User Id:</label>
                                    {/* <label className="payments-data__field">6464645656 <i className="fa fa-clone" aria-hidden="true" title="click to copy" alt="click to copy"></i></label> */}
                                    <input className="form-control" type="text" aria-label="Disabled input example" disabled value={this.props.userId}></input>
                                </div>
                                <div className='col-12 col-sm-3 col-md-3'>
                                    <label htmlFor="inputPassword5" className="form-label">Email Id:</label>
                                    <input type="text" id="disabledTextInput" className="form-control" disabled value={this.props.emailId}></input>
                                </div>
                                <div className='col-12 col-sm-3 col-md-3'>
                                    <label htmlFor="inputPassword5" className="form-label">Mobile Number:</label>
                                    <input type="text" id="disabledTextInput" className="form-control" disabled value={this.props.mobileNumber}></input>
                                </div>
                                {['ICEPE', 'ICEPE1X', 'PAYOK'].includes(this.props?.activePaymentOption?.gatewayProvider?.pgName) &&
                                    <div className='col-12 col-sm-3 col-md-3'>
                                        <label htmlFor="inputPassword5" className="form-label">Upi Address</label>
                                        <input type="text" id="disabledTextInput" className="form-control" placeholder='Write your UPI address' name='customerUpi' value={this.state.customerUpi} onChange={(e) => this.setState({ customerUpi: e.target.value, })}></input>
                                    </div>
                                }

                                {!!this.props?.activePaymentOption?.gatewayProvider?.conversionRate &&
                                    <div className='col-12 col-sm-3 col-md-3'>
                                        <label htmlFor="inputPassword5" className="form-label">Conversion Rate:</label>
                                        <input className="form-control" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption?.gatewayProvider?.conversionRate}></input>
                                    </div>
                                }

                                {!!this.props?.activePaymentOption?.gatewayProvider?.conversionRate &&
                                    <div className='col-12 col-sm-3 col-md-3'>
                                        <label htmlFor="inputPassword5" className="form-label">Deposit Amount in Crypto:</label>
                                        <input className="form-control" type="text" aria-label="Disabled input example" disabled value={!!this.props.amount ? ((this.props.amount / this.props?.activePaymentOption?.gatewayProvider?.conversionRate).toFixed(8)) : ''}></input>
                                    </div>
                                }

                                {!!this.props?.activePaymentOption.paymentModeOptions &&
                                    <div className='col-12 col-sm-3 col-md-3'>
                                        <label htmlFor="inputPassword5" className="form-label">Payment Mode:</label>
                                        <select className="form-control" name='selectedPaymentModeOption' value={this.state.selectedPaymentModeOption} onChange={(e) => this.setState({ selectedPaymentModeOption: e.target.value, })}>
                                            <option value={''}> Select </option>
                                            {
                                                this.props?.activePaymentOption.paymentModeOptions.map((opttt, inx) => {
                                                    return (
                                                        <option value={opttt} key={opttt}>{opttt}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                }


                                <div className='col-12 col-sm-3 col-md-3 mt-4'>
                                    <div className={`${['ICEPE', 'ICEPE1X', 'PAYOK'].includes(this.props?.activePaymentOption?.gatewayProvider?.pgName) ? 'mt-3' : 'mt-1'}`}>
                                        <button className="btn btn-payment-submit" disabled={this.state.buttonLoader} onClick={() => { if (['PAYOK'].includes(this.props?.activePaymentOption?.gatewayProvider?.pgName)) { this.openDepositInfoPopup(); } else { this.onSubmitClick(); } }}>
                                            {this.state.buttonLoader &&
                                                <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                </svg>}
                                            Deposit
                                        </button>
                                    </div>
                                </div>

                                <div className={`payments-help ${['ICEPE', 'ICEPE1X', 'PAYOK'].includes(this.props?.activePaymentOption?.gatewayProvider?.pgName) ? 'pt-3' : ''}`}>
                                    <span className="payments-help__icon"><i className="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                    <div className="payments-help__body">
                                        <p className="payments-help__text">Amount should be atleast {!!this.props.activePaymentOption?.minLimit && this.props.activePaymentOption?.minLimit > 0 ? this.props.activePaymentOption?.minLimit : 100}.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                }
                {/* Cash payment Start */}
                {this.props.gateWay === 'cash' &&
                    <div className="row manual-container-qr payment-details-box ">
                        <div className="col-12 col-sm-12 col-md-12">
                            <div className='row'>
                                <div className='col-12 col-sm-4 col-md-3'>
                                    <label htmlFor="inputPassword5" className="form-label">Support Number 1:</label>
                                    <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={!!this.props?.activePaymentOption && !!this.props?.activePaymentOption.support_number1 ? this.props?.activePaymentOption.support_number1 : ''}></input>
                                    <i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(!!this.props?.activePaymentOption && !!this.props?.activePaymentOption.support_number1 ? this.props?.activePaymentOption.support_number1 : '')}></i>
                                </div>
                                <div className='col-12 col-sm-4 col-md-3'>
                                    <label htmlFor="inputPassword5" className="form-label">Support Number 2:</label>
                                    {/* <label className="payments-data__field">6464645656 <i className="fa fa-clone" aria-hidden="true" title="click to copy" alt="click to copy"></i></label> */}
                                    <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={!!this.props?.activePaymentOption && !!this.props?.activePaymentOption.support_number2 ? this.props?.activePaymentOption.support_number2 : ''}></input>
                                    <i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(!!this.props?.activePaymentOption && !!this.props?.activePaymentOption.support_number2 ? this.props?.activePaymentOption.support_number2 : '')}></i>
                                </div>

                                <div className='col-12 col-sm-4 col-md-3'>
                                    <label htmlFor="inputPassword5" className="form-label">Amount:</label>
                                    <input type="text" id="disabledTextInput" className="form-control" placeholder="" disabled value={this.props.amount}></input>
                                </div>

                                <div className='col-12 col-sm-4 col-md-3'>
                                    <div className="mt-4">
                                        <button className="btn btn-payment-submit" disabled={this.state.buttonLoader} onClick={() => this.onSubmitClick()}>
                                            {this.state.buttonLoader &&
                                                <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                    <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                </svg>}
                                            Submit
                                        </button>
                                    </div>
                                </div>

                                <div className="payments-help">
                                    <span className="payments-help__icon"><i className="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                    <div className="payments-help__body">
                                        <p className="payments-help__text">For more information call on above number.</p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                }
                {/* Cash payment End */}
                {/* mqr payment Start */}
                {this.props.gateWay === 'mqr' &&
                    <>
                        {!!this.state.mqrImgDt ?
                            <div className="row manual-container-qr border-0">
                                <div className='col-12 col-sm-4 col-md-2 d-none-mobile'>&nbsp;</div>
                                <div className='col-12 col-sm-4 col-md-8'>
                                    <div className='payment-details-box-m'>
                                        {this.state.mqrtimerseconds > 0 && <div className="mb-1 qrcode-timer1 qrcode-timer-m "><span>Payment Time</span>{this.state.mqrtimerdisplay}</div>}
                                        <div className='qrboxmain-m'>
                                            <div className="mb-1">
                                                <div className="payment-methods__form-head-title upi1-title-m">Transfer Amount</div>
                                                <div className="payment-methods__form-head-title upi1-amount-m">Rs. {this.props.amount}.00/-</div>
                                            </div>

                                            <div className="payment-methods__form-head text-center">
                                                <span className="payment-methods__form-head-title upi1-title-m font-14">Scan & Pay the exact amount only & submit UTR</span>
                                            </div>
                                            <div id="screenshotElement" className="manual-deposit-QR-m text-center">
                                                {/* <img src="https://img-dev.xorope.io/RDR/PhonePe/6549848942454.png?1714120715069" alt="" /> */}
                                                <div className='qrcreate-m'>
                                                    <QRCode
                                                        value={this.state.mqrImgDt}
                                                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="mb-1">
                                                <div className="payment-methods__form-head-title upi1-title-m"><span className="receipt-color">Receipt:</span> {this.state.receiptID}</div>
                                            </div>
                                            <div className='inputboxpay-m mb-3 '>
                                                <div className="inputboxpayw-m">
                                                    <label for="inputPassword5" className="form-label mb-1">Upi Id: </label>
                                                    <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={this?.props?.activePaymentOption?.accountNumber} /><i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this?.props?.activePaymentOption?.accountNumber)}></i>
                                                </div>
                                            </div>
                                            <div className='inputboxpay-m mt-1'>
                                                <div className="inputboxpayw-m">
                                                    <label for="inputPassword5" className="form-label mb-1">Enter UTR Number:</label>
                                                    <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled="" value={this.state.utrNumber} onChange={(e) => { this.setState({ utrNumber: e.target.value, }); }} />
                                                </div>
                                            </div>
                                            <div className='inputboxpay-m mt-2_5'>
                                                <div className='inputboxpayw-m'>
                                                    <button className="btn btn-green w-48-m mr-2" onClick={() => { this.submitPaymentWithUtr() }}>SUBMIT</button>
                                                    <button className="btn w-48-m btn-danger" onClick={() => this.onCancelClick()}>CANCEL</button>
                                                </div>
                                            </div>
                                            <div className='inputboxpay-m mt-2_5'>
                                                <div className='inputboxpayw-m text-center'>
                                                    <img className='cursor w-50' alt="" src={`${BASE_IMAGE_PATH}/casino/banner/loginimages/securepayment.png`} onClick={() => window.open(this.state.upiDirectButtonLink['phonepe'], '_blank')} />
                                                </div>
                                            </div>
                                        </div>
                                        {!!Object.keys(DEPOSIT_MQR_DEMO_BTN) && Object.keys(DEPOSIT_MQR_DEMO_BTN)?.length > 0 &&
                                            <DepositDemoDropdownMenu />
                                        }
                                    </div>
                                </div>
                                <div className='col-12 col-sm-4 col-md-2 d-none-mobile'>&nbsp;</div>
                            </div>
                            :
                            <div className="row manual-container-qr payment-details-box">
                                <div className="col-12 col-sm-12 col-md-12">
                                    <div className='row'>
                                        <div className='col-12 col-sm-3 col-md-3'>
                                            <label htmlFor="inputPassword5" className="form-label">Amount (INR):</label>
                                            <input className="form-control" type="text" placeholder="" aria-label="Disabled input example" disabled value={this.props.amount}></input>
                                        </div>
                                        <div className='col-12 col-sm-3 col-md-3'>
                                            <label htmlFor="inputPassword5" className="form-label">Email Id:</label>
                                            <input type="text" id="disabledTextInput" className="form-control" placeholder="" disabled value={this.props.emailId}></input>
                                        </div>
                                        <div className='col-12 col-sm-3 col-md-3'>
                                            <label htmlFor="inputPassword5" className="form-label">Mobile Number:</label>
                                            <input type="text" id="disabledTextInput" className="form-control" placeholder="" disabled value={this.props.mobileNumber}></input>
                                        </div>
                                        <div className='col-12 col-sm-3 col-md-3 mt-2'>
                                            <div className="mt-3">
                                                <button className="btn btn-payment-submit" disabled={this.state.buttonLoader} onClick={() => this.onSubmitClick()}>
                                                    {this.state.buttonLoader &&
                                                        <svg className="spinner mr-2" viewBox="0 0 50 50">
                                                            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5" style={{ stroke: '#82aadc' }}></circle>
                                                        </svg>}
                                                    Deposit
                                                </button>
                                            </div>
                                        </div>

                                        {/* <div className="payments-help">
                                        <span className="payments-help__icon"><i className="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                        <div className="payments-help__body">
                                            <p className="payments-help__text">If Amount Greater Than 100,000</p>
                                        </div>
                                    </div> */}

                                    </div>
                                </div>
                            </div>
                        }
                    </>
                }
                {/* mqr payment End */}
                {/* Whatsapp  payment Start */}
                {this.props.gateWay === 'whatsapp' &&
                    // <div className='payment-details-box row'>
                    //     <div className='col-9 col-sm-8 col-md-8'>
                    //         <div className='mt-3'>Click WhatsApp to deposit instantly - available 24x7.</div>
                    //     </div>
                    //     <div className='col-3 col-sm-4 col-md-4 whatsapp_btn_right'>
                    //         <img className='whatsapp-id-iw' src={`${BASE_IMAGE_PATH}/casino/wallet/whatsapp-id.png`} alt='' onClick={() => { window.open(`https://wa.me/+${this.props.activePaymentOption?.gatewayProvider?.whatsappData[0]?.mobileNumber}`, "_blank") }}/>
                    //     </div>
                    // </div>
                    <>
                        <div className='cursor payment-details-box row' onClick={() => { window.open(`https://wa.me/+${this.props?.activePaymentOption.accountNumber}`, "_blank") }} >
                            <div className=''>
                                <div className='whatsapp_text_iw_id'>Click WhatsApp to deposit instantly - available 24x7.</div>
                            </div>
                        </div>
                        <div className='cursor whatsapp_btn_right_iw_id' onClick={() => { window.open(`https://wa.me/+${this.props?.activePaymentOption.accountNumber}`, "_blank") }} >
                            <img className='whatsapp-id-iw' src={`${BASE_IMAGE_PATH}/casino/wallet/whatsapp-id.png`} alt='' onClick={() => { window.open(`https://wa.me/+${this.props?.activePaymentOption.accountNumber}`, "_blank") }} />
                        </div>
                    </>
                }
                {/* Whatsapp  payment End */}
                {/* wizpay  payment End */}
                {!!this.props?.activePaymentOption && !!this.props?.activePaymentOption?.gatewayProvider && this.props?.activePaymentOption?.gatewayProvider === "XOROPE" && !['cash', 'mqr', 'whatsapp'].includes(this.props.gateWay) &&
                    <>
                        {!!this.props?.activePaymentOption && ["bkash", "nagad", "rocket", "upay", "bank", "bankpr"].includes(this.props.gateWay) &&
                            <div className="row manual-container-qr payment-details-box">
                                {
                                    this.props.gateWay !== "bank" && this.props.gateWay !== "bankpr" &&
                                    <div className="col-12 col-sm-4 col-md-3">
                                        <div className="">
                                            <div className="payment-methods__form-head">
                                                <span className="payment-methods__form-head-title UPI-title">Scan the QR code to pay</span>
                                            </div>
                                            <div className="manual-deposit-QR">
                                                <img src={this.props?.activePaymentOption?.qrCode} alt="" />
                                            </div>
                                            <div className="manual-min-max text-left w-100">
                                                <span className="mr-2">Min:{this.props?.activePaymentOption?.minLimit}</span>
                                                <span>Max:{this.props?.activePaymentOption?.maxLimit}</span>
                                            </div>
                                        </div>
                                    </div>
                                }
                                <div className={(this.props.gateWay === "bank" || this.props.gateWay === "bankpr") ? "col-12 col-sm-12 col-md-12" : "col-12 col-sm-8 col-md-9"}>
                                    <div className='row'>
                                        {(this.props.gateWay === "bank" || this.props.gateWay === "bankpr") &&
                                            <div className='col-12 col-sm-3 col-md-3'>
                                                <label htmlFor="inputPassword5" className="form-label">Bank Name:</label>
                                                <input className="form-control" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption?.bankName}></input>
                                            </div>
                                        }
                                        <div className={this.props.gateWay === "bank" ? 'col-12 col-sm-3 col-md-3' : 'col-12 col-sm-4 col-md-4'}>
                                            <label htmlFor="inputPassword5" className="form-label">{this.props.gateWay === "bank" ? 'Account Holder Name' : (this.props.gateWay === 'crypto' ? 'Wallet Type' : 'Account Name')}:</label>
                                            <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption[(this.props.gateWay === "bank" ? 'holderName' : (this.props.gateWay === 'crypto' ? 'holderName' : 'holderName'))]}></input>
                                            <i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this.props?.activePaymentOption[(this.props.gateWay === "bank" ? 'holderName' : (this.props.gateWay === 'crypto' ? 'holderName' : 'holderName'))])}></i>
                                        </div>

                                        <div className={(this.props.gateWay === "bank" || this.props.gateWay === "bankpr") ? 'col-12 col-sm-3 col-md-3' : 'col-12 col-sm-4 col-md-4'}>
                                            <label htmlFor="inputPassword5" className="form-label">{this.props.gateWay === "bankpr" ? "IBAN Number" : this.props.gateWay === "bank" ? 'Account Number' : 'Wallet'}:</label>
                                            <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption[(this.props.gateWay === "bank" || this.props.gateWay === "bankpr" ? 'accountNumber' : (this.props.gateWay === 'crypto' ? 'accountNumber' : 'accountNumber'))]}></input>
                                            <i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this.props?.activePaymentOption[(this.props.gateWay === "bank" || this.props.gateWay === "bankpr" ? 'accountNumber' : (this.props.gateWay === 'crypto' ? 'accountNumber' : 'accountNumber'))])}></i>
                                        </div>
                                        {
                                            (this.props.gateWay === "bank") &&
                                            <div className='col-12 col-sm-3 col-md-3'>
                                                <label htmlFor="inputPassword5" className="form-label">IFSC Code:</label>
                                                <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption?.ifscCode}></input>
                                                <i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this.props?.activePaymentOption?.ifscCode)}></i>
                                            </div>
                                        }
                                        {
                                            this.props.gateWay === "crypto" &&
                                            <div className='col-12 col-sm-4 col-md-4'>
                                                <label htmlFor="inputPassword5" className="form-label">Conversion Rate:</label>
                                                <input className="form-control" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption.conversionRate}></input>
                                            </div>
                                        }
                                        <div className={(this.props.gateWay === "bank" || this.props.gateWay === "bankpr") ? 'col-12 col-sm-3 col-md-3 mt-2' : (this.props.gateWay === 'crypto' ? 'col-12 col-sm-4 col-md-4 mt-2' : 'col-12 col-sm-4 col-md-4')}>
                                            <label htmlFor="inputPassword5" className="form-label">Amount:</label>
                                            <input type="text" id="disabledTextInput" className="form-control" disabled value={this.props.amount}></input>
                                            <small>Min: {this.props.activePaymentOption.minLimit} <span className='ml-2'>Max: {this.props.activePaymentOption.maxLimit}</span></small>
                                        </div>
                                        <div className={(this.props.gateWay === "bank" || this.props.gateWay === "bankpr") ? 'col-12 col-sm-3 col-md-3 mt-2' : 'col-12 col-sm-4 col-md-4 mt-2'}>
                                            <label htmlFor="inputPassword5" className="form-label">{(this.props.gateWay === 'crypto' || this.props.gateWay === "bankpr" ? 'Trns No' : (["nagad", "bkash", "rocket", "upay"].includes(this.props.gateWay) ? 'Transaction Id' : 'UTR No'))}:</label>
                                            <input type="text" id="disabledTextInput" className="form-control" placeholder={(this.props.gateWay === 'crypto' || this.props.gateWay === "bankpr" ? 'Enter Your Trns Here' : (["nagad", "bkash", "rocket", "upay"].includes(this.props.gateWay) ? 'Enter Transaction Id' : 'Enter Your UTR Here'))} autoComplete="off" value={this.state.utr} onKeyPress={(e) => { if (!onlyAlphaNumeric.test(e.key)) { e.preventDefault() } }} onPaste={(e) => this.onCryptoTrnnoPaste(e)} onChange={(e) => { this.setState({ utr: e.target.value, }); }} />
                                        </div>
                                        {
                                            this.props?.activePaymentOption?.screenshot &&
                                            <div className={this.props.gateWay === "bank_account" ? 'col-12 col-sm-3 col-md-3 mt-2' : 'col-12 col-sm-4 col-md-4 mt-2'}>
                                                <label htmlFor={`formFile_${this.props.gateWay}`} className="form-label">Upload Screenshot:</label>
                                                <input className="form-control" type="file" id={`formFile_${this.props.gateWay}`} accept="image/*" onChange={this.selectFile} />
                                            </div>
                                        }
                                        <div className={(this.props.gateWay === "bank" || this.props.gateWay === "bankpr") ? 'col-12 col-sm-3 col-md-3 mt-2' : 'col-12 col-sm-4 col-md-4 mt-2'}>
                                            <div className="mt-4">
                                                <button className="btn btn-payment-submit" disabled={this.state.buttonLoader} onClick={() => this.onSubmitClick()}>Submit</button>
                                            </div>
                                        </div>

                                        <div className="payments-help">
                                            <span className="payments-help__icon"><i className="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                            <div className="payments-help__body">
                                                <p className="payments-help__text">Once you make the payment to the above account, Enter required details below and confirm successful deposit.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
                }
                {!!this.props?.activePaymentOption && !!this.props?.activePaymentOption?.gatewayProvider && this.props?.activePaymentOption?.gatewayProvider === "XOROPE" && !['cash', 'mqr', 'whatsapp'].includes(this.props.gateWay) &&
                    <>
                        <div className="row manual-container-qr border-0">
                            <div className='col-12 col-sm-4 col-md-2'>&nbsp;</div>
                            <div className='col-12 col-sm-4 col-md-8'>
                                {!!this.props?.activePaymentOption && !["bkash", "nagad", "rocket", "upay", "bank", "cash", "mqr", "bankpr"].includes(this.props.gateWay) &&
                                    <>
                                        {!!this.props.amount ?
                                            <div className='payment-details-box-m'>
                                                {this.state.mqrtimerseconds > 0 && <div className="mb-1 qrcode-timer1 qrcode-timer-m "><span>Payment Time</span>{this.state.mqrtimerdisplay}</div>}
                                                <div className='qrboxmain-m'>
                                                    <div className="mb-1">
                                                        <div className="payment-methods__form-head-title upi1-title-m">Transfer Amount</div>
                                                        <div className="payment-methods__form-head-title upi1-amount-m">{this.props.gateWay !== 'crypto' && 'Rs.'} {this.props.amount}.00/-</div>
                                                    </div>

                                                    <div className="payment-methods__form-head text-center">
                                                        <span className="payment-methods__form-head-title upi1-title-m font-14">Scan & Pay the exact amount only & submit {this.props.gateWay === 'wallet' ? 'transaction no.' : 'UTR'}</span>
                                                    </div>
                                                    <div id="screenshotElement" className="manual-deposit-QR-m text-center">
                                                        {/* <img src="https://img-dev.xorope.io/RDR/PhonePe/6549848942454.png?1714120715069" alt="" /> */}
                                                        <div className='qrcreate-m'>
                                                            <img src={this.props?.activePaymentOption?.qrCode} alt="" />
                                                            {/* <QRCode
                                                                value={this.state.mqrImgDt}
                                                                style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                                                            /> */}
                                                        </div>

                                                        {/* <div className="manual-deposit-QR">
                                                <img src={this.props.activePaymentOption.qrCode} alt="" />
                                            </div> */}
                                                    </div>
                                                    <div className="mb-1">
                                                        <div className="manual-min-max text-center payment-methods__form-head-title upi1-title-m">
                                                            <span className="mr-2">Min:{this.props?.activePaymentOption?.minLimit}</span>
                                                            <span>Max:{this.props?.activePaymentOption?.maxLimit}</span>
                                                        </div>
                                                    </div>
                                                    {/* <div className='inputboxpay-m mb-2 '>
                                                        {this.props.gateWay !== 'crypto' &&
                                                        <div className="inputboxpayw-m">
                                                            <label for="inputPassword6" className="form-label mb-1">Upi Id: </label>
                                                            <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={this?.props?.activePaymentOption?.accountNumber} /><i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this?.props?.activePaymentOption?.accountNumber)}></i>
                                                        </div>
                                                        }
                                                    </div> */}
                                                    <div className='inputboxpay-m mb-2 '>
                                                        <div className="inputboxpayw-m ">
                                                            <label htmlFor="inputPassword5" className="form-label">{this.props.gateWay === 'crypto' ? 'Wallet Type' : 'Account Name'}:</label>
                                                            <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption[this.props.gateWay === 'crypto' ? 'holderName' : 'holderName']}></input>
                                                            <i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this.props?.activePaymentOption[this.props.gateWay === 'crypto' ? 'holderName' : 'holderName'])}></i>
                                                        </div>
                                                    </div>
                                                    <div className='inputboxpay-m mb-2 '>
                                                        <div className="inputboxpayw-m ">
                                                            <label htmlFor="inputPassword5" className="form-label">Wallet:</label>
                                                            <input className="form-control copy-icon-new-input" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption[this.props.gateWay === 'crypto' ? 'accountNumber' : 'accountNumber']}></input>
                                                            <i className="fa fa-clone copy-icon-new" aria-hidden="true" title="click to copy" alt="click to copy" onClick={() => this.copyToClipboard(this.props?.activePaymentOption[this.props.gateWay === 'crypto' ? 'accountNumber' : 'accountNumber'])}></i>
                                                        </div>
                                                    </div>
                                                    {
                                                        this.props.gateWay === "crypto" &&
                                                        <div className='inputboxpay-m mb-2 '>
                                                            <div className="inputboxpayw-m ">
                                                                <label htmlFor="inputPassword5" className="form-label">Conversion Rate:</label>
                                                                <input className="form-control" type="text" aria-label="Disabled input example" disabled value={this.props?.activePaymentOption?.conversionRate}></input>
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className='inputboxpay-m mb-2 '>
                                                        <div className="inputboxpayw-m ">
                                                            <label htmlFor="inputPassword5" className="form-label">Amount:</label>
                                                            <input type="text" id="disabledTextInput" className="form-control" disabled value={this.props.amount}></input>
                                                        </div>
                                                    </div>
                                                    <div className='inputboxpay-m mb-2 '>
                                                        <div className="inputboxpayw-m ">
                                                            <label htmlFor="inputPassword5" className="form-label">{(this.props.gateWay === 'crypto' || this.props.gateWay === 'wallet' ? 'Trns No' : 'UTR No')}:</label>
                                                            <input type="text" id="disabledTextInput" className="form-control" placeholder={(this.props.gateWay === 'crypto' || this.props.gateWay === 'wallet' ? 'Enter Your Trns Here' : 'Enter Your UTR Here')} autoComplete="off" value={this.state.utr} onKeyPress={(e) => { if (!onlyAlphaNumeric.test(e.key)) { e.preventDefault() } }} onPaste={(e) => this.onCryptoTrnnoPaste(e)} onChange={(e) => { this.setState({ utr: e.target.value, }); }} />
                                                        </div>
                                                    </div>

                                                    {
                                                        this.props?.activePaymentOption?.screenshot &&
                                                        <div className='inputboxpay-m mb-2 '>
                                                            <div className="inputboxpayw-m ">
                                                                <label htmlFor={`formFile_${this.props.gateWay}`} className="form-label">Upload Screenshot:</label>
                                                                <input className="form-control" type="file" id={`formFile_${this.props.gateWay}`} accept="image/*" onChange={this.selectFile} />
                                                            </div>
                                                        </div>
                                                    }
                                                    <div className='inputboxpay-m mb-2 '>
                                                        <div className="inputboxpayw-m ">
                                                            <div className="payments-help">
                                                                <span className="payments-help__icon"><i className="fa fa-exclamation-circle" aria-hidden="true"></i></span>
                                                                <div className="payments-help__body">
                                                                    <p className="payments-help__text">Once you make the payment to the above account, Enter required details below and confirm successful deposit.</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='inputboxpay-m mt-2_5'>
                                                        <div className='inputboxpayw-m'>
                                                            <button className="btn btn-green w-48-m mr-2" disabled={this.state.buttonLoader} onClick={() => this.onSubmitClick()}>Submit</button>
                                                            <button className="btn w-48-m btn-danger" onClick={() => this.onCancelClick()}>Cancel</button>
                                                        </div>
                                                    </div>
                                                    <div className='inputboxpay-m mt-2_5'>
                                                        <div className='inputboxpayw-m text-center'>
                                                            <img className='cursor w-50' alt="" src={`${BASE_IMAGE_PATH}/casino/banner/loginimages/securepayment.png`} onClick={() => window.open(this.state.upiDirectButtonLink['phonepe'], '_blank')} />
                                                        </div>
                                                    </div>
                                                </div>
                                                {!!Object.keys(DEPOSIT_MQR_DEMO_BTN) && Object.keys(DEPOSIT_MQR_DEMO_BTN)?.length > 0 &&
                                                    <DepositDemoDropdownMenu />
                                                }
                                            </div>
                                            :
                                            (this.props.showAmountDiv && <div className='text-center font-bold font-18'>Select Amount First</div>)
                                        }
                                    </>
                                }
                            </div>
                            <div className='col-12 col-sm-4 col-md-2'>&nbsp;</div>
                        </div>
                    </>
                }
            </>
        )
    }
}
function mapStateToProps(state) {
    return {
    };
}
function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(WalletDepositInnerComp);